import React, { useState, useEffect } from 'react';

const CountdownTimer = (props) => {
  const { showSeconds = true, showCountUp = false } = props;
  const initialTime = (new Date(props.maxClosedDate) - Date.now());
  const [timeRemaining, setTimeRemaining] = useState();

  useEffect(() => {
    setTimeRemaining(initialTime / 1000);
    const timerInterval = setInterval(() => {
      setTimeRemaining((prevTime) => {
        if (!showCountUp && prevTime < 1) {
          clearInterval(timerInterval);
          return 0;
        } else {
          return prevTime - 1;
        }
      });
    }, 1000);

    // Cleanup the interval when the component unmounts
    return () => clearInterval(timerInterval);
  }, [props]); // Runs if the props change

  // If we don't show seconds, add 60 seconds to the time remaining
  let timeRemainingCorrected = timeRemaining;
  if(!showSeconds) {
    timeRemainingCorrected += 60;
  }

  if(showCountUp && timeRemainingCorrected < 0) {
    timeRemainingCorrected = timeRemainingCorrected * -1;
  }

  // Convert seconds to hours, minutes, and seconds
  const hours = Math.floor(timeRemainingCorrected / 3600);
  const minutes = Math.floor((timeRemainingCorrected % 3600) / 60);
  const seconds = Math.floor(timeRemainingCorrected % 60);

  return (
      <>
        { showSeconds ? `${hours}h ${minutes}m ${seconds}s` : `${hours}h ${minutes}m` }
      </>
  );
};

export default CountdownTimer;